export enum BpmnTimerTypes {
    Duration = "Duration",
    Date = "Date"
}